import React, { useState } from 'react';
import { FiMail } from 'react-icons/fi';
import A1 from '../Login/Chatbot.jpeg';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        setError('');
        try {
            const res = await fetch('https://botapi.emedha.in/auth/api/forgot-passwordbot', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });

            const data = await res.json();

            if (res.ok) {
                setMessage(data.message);
            } else {
                setError(data.error || 'Something went wrong');
            }
        } catch (err) {
            console.error(err);
            setError('Server error. Please try again.');
        }

        setLoading(false);
    };

    return (
        <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
            <div className="card shadow p-4" style={{ maxWidth: '400px', width: '100%' }}>
                <div className="text-center mb-3">
                    <h2 className="fw-bold text-primary">Emedha ChatBot <span className="text-success">Services</span></h2>
                    <img src={A1} alt="ChatBot Services" style={{ width: '100px', borderRadius: '50%' }} />
                    <h4 className="mt-3 mb-2">Forgot Password</h4>
                    <p className="text-muted small">We'll send you a link to reset your password</p>
                </div>

                {message && <div className="alert alert-success">{message}</div>}
                {error && <div className="alert alert-danger">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email address</label>
                        <div className="input-group">
                            <span className="input-group-text bg-white"><FiMail /></span>
                            <input type="email" id="email" className="form-control" placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
                        </div>
                    </div>
                    <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                        {loading ? 'Sending...' : 'Send Reset Link'}
                    </button>
                </form>

                <div className="text-center mt-3">
                    <a href="/" className="text-decoration-none">← Back to Login</a>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
